import { createFileRoute } from "@tanstack/react-router";
import { AccessManagement } from "@/components/AccessManagement";

function RouteComponent() {
  return <AccessManagement />;
}

export const Route = createFileRoute("/_authenticated/access-management/")({
  component: RouteComponent,
  staticData: { page: "admin" },
});
